module.exports = __webpack_public_path__ + "static/media/flag_kor.d50e92b2.png";